import { Box, Typography } from '@mui/material'
import { TickIcon } from 'icons'
import React, { FC } from 'react'

import { HintProps } from './Hint.types'

export const Hint: FC<React.PropsWithChildren<HintProps>> = ({
  children,
  isChecked,
}) => {
  return (
    <Box
      sx={{
        width: {
          xs: '100%',
          sm: '49%',
        },
      }}
      display='flex'
      alignItems='flex-start'
    >
      <TickIcon
        width={24}
        height={24}
        color={isChecked ? '#009970' : 'rgba(34, 34, 34, 0.48)'}
      />
      <Typography
        fontSize={14}
        fontWeight={400}
        color={isChecked ? '#009970' : 'rgba(34, 34, 34, 0.48)'}
        whiteSpace={'nowrap'}
      >
        {children}
      </Typography>
    </Box>
  )
}
